import { ReadModeBuilder } from './../../models/builders/read-mode.builder';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ReadModeApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }read-modes`;
  }

  getReadModes() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(ReadModeBuilder.fromList));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/read-mode-api.service.ts